import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SaveWeatherSettingsResponse, UserDataWeatherInput, UserWeatherSettings } from '../../../../models/weather-widget.model';
import { ApiEndpointsService } from '../../../../services/api-endpoints.service';
import { SAVE_USER_WEATHER_SETTINGS_MUTATION } from '../../../../shared/graphql/user-weather-settings.mutation';

@Injectable({ providedIn: 'root' })
export class WeatherSettingsService {
  private readonly http = inject(HttpClient);
  private readonly apiService = inject(ApiEndpointsService);

  /**
   * Save user weather settings to the api
   * @param data The weather settings to save
   * @returns Observable of saved UserWeatherSettings or null on error
   */
  saveUserWeatherSettings(data: UserDataWeatherInput): Observable<UserWeatherSettings | null> {
    const query = SAVE_USER_WEATHER_SETTINGS_MUTATION;
    const variables = { data };

    return this.http.post<SaveWeatherSettingsResponse>(this.apiService.baseUrl, { query, variables }, { withCredentials: true }).pipe(
      map((response) => {
        const savedData = response?.data?.userData;
        if (!savedData) {
          console.warn('No data returned from save mutation');
          return null;
        }
        console.log('Weather settings saved successfully:', savedData);
        return savedData;
      }),
      catchError((err) => {
        console.error('Failed to save weather settings', err);
        return of<null>(null);
      })
    );
  }
}
